import React from "react";
// import { PropTypes } from "prop-types";
import { LinkSimple } from "../../_atoms/_link-simple/LinkSimple";

import "./_car-data.scss";

export const CarData = ({
  brand,
  tabs,
  children,
  vin,
  name,
  model,
  business,
  ecode,
  plate,
  onClick,
  showPacket,
  firstRegistrationDate,
  type,
}) => {
  const content = require(`../../../data/${brand}-lang.es.json`);
  const searchTxt = content.search;

  const carDate = firstRegistrationDate.split('.');
  const period = new Date(new Date().getTime() - new Date(carDate[2] + '-' + carDate[1] + '-' + carDate[0]).getTime());
  const years = period.getFullYear() - 1970;

  return (
    <div className="car-data">
      <div className="car-data__img">
        {!!plate && (
          <img
            src={`https://api.bmw.es/cosy/?image=${ecode}.jpg`}
            //src={`https://a4i-es.bmwgroup.com/webApis/Generator/ByVin?vin=${vin}&pov=FRONTSIDE&height=608&width=1080&format=PNG&throwError=True`}
            alt=""
          />
        )}
        {!plate && (
          <img src={`https://api.bmw.es/cosy/?image=${ecode}.jpg`} alt="" />
        )}
      </div>
      <div className="car-data__specs">
        <div>
          <span className="h3">{model}</span>

          <ul className="list">
            {!!plate && (
              <li>
                <dl>
                  <dt>Matrícula</dt>
                  <dd>
                    {plate}{" "}
                    <LinkSimple
                      aria=""
                      type="link"
                      css="link-simple--1"
                      children=" Cambiar "
                      onClick={onClick}
                    />{" "}
                  </dd>
                </dl>
              </li>
            )}
            <li>
              <dl>
                <dt>Modelo</dt>
                <dd>
                  {ecode}
                  {!plate && (
                    <LinkSimple
                      aria=""
                      type="link"
                      css="link-simple--1"
                      children=" Cambiar "
                      onClick={onClick}
                    />
                  )}
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>
      {/*showPacket && (
        <div className="car-data__data">
          <ul className="list">
            <li>
              <dl>
                <dt>Paquete contratado</dt>
                <dd>
                  {business === "SI" && "BSI"}
                  {business === "SI+" && "BSI+"}
                  {business !== "SI" && business !== "SI+" && "-"}
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>Duración</dt>
                <dd>
                  {name}
                  {!name && "-"}
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>Fecha fin BSI</dt>
                <dd>{firstRegistrationDate}</dd>
              </dl>
            </li>
          </ul>
        </div>
      )*/}
    </div>
  );
};

// CarData.js.propTypes = {
//   ￼: PropTypes.￼.isRequired,
// };
